<div class="wrapper flex vcenter">
  <span class="message error grow1"
    >Valami hiba történt, kérjük próbálja újra később vagy keresse fel
    <!-- <a class="link" href="https://payee.tech/contact" target="_blank">ügyvédi irodánkat!</a> -->
    ügyvédi irodánkat!
  </span>
  <a class="action" (click)="dismiss()">OK</a>
</div>
